/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 凭证</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019年08月01日</li>
 * <li>@author     : ____′↘夏悸</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';
import Utils from '../js/common/utils';
import axios from 'axios';
import Qs from "qs";

export default {
	list(params) {
		return Ajax.get("/voucher", params)
	},
	load(id) {
		return Ajax.get(`/voucher/${id}`)
	},
	loadCode(params) {
		return Ajax.get(`/voucher/code`, params)
	},
	summary() {
		return Ajax.get(`/voucher/summary`)
	},
	delete(id) {
		return Ajax.delete(`/voucher/${id}`)
	},
	save(params = {}) {
		return Ajax.post(`/voucher`, params)
	},
	update(params = {}) {
		return Ajax.put(`/voucher`, params)
	},
	carryForwardMoney(params = {}) {
		return Ajax.post(`/voucher/carryForwardMoney`, Qs.stringify(params, {indices: false}))
	},
	finishingOffNo(params = {}) {
		return Ajax.get(`/voucher/finishingOffNo`, params)
	},
	beforeId(params = {}) {
		return Ajax.get(`/voucher/beforeId`, params)
	},
	nextId(params = {}) {
		return Ajax.get(`/voucher/nextId`, params)
	},
	batchDelete(params = {}) {
		return Ajax.post(`/voucher/batchDelete`, Qs.stringify(params, {indices: false}))
	},
	audit(params = {}) {
		return Ajax.post(`/voucher/audit`, Qs.stringify(params, {indices: false}))
	},
	cancelAudit(params = {}) {
		return Ajax.post(`/voucher/cancelAudit`, Qs.stringify(params, {indices: false}))
	},
	batchReject(params = {}) {
		return Ajax.post(`/voucher/batchReject`, Qs.stringify(params, {indices: false}))
	},
	import(params) {
		return Ajax.post(`/voucher/import`, params, {'Content-Type': 'multipart/form-data'})
	},
	merge(params = {}) {
		return Ajax.post(`/voucher/merge`, Qs.stringify(params, {indices: false}))
	},
	insert(params = {}) {
		return Ajax.post(`/voucher/insert`, Qs.stringify(params, {indices: false}))
	},
	checkBreakNo(params = {}) {
		return Ajax.get(`/voucher/checkBreakNo`, params)
	},
	download(params = {}) {
		return axios.post('/api/voucher/download', params, {
			responseType: 'blob',
			headers: {author: Utils.getAuthor() || 'gson', 'X-Requested-With': 'XMLHttpRequest'}
		})
	},
	bookSignExport(params) {
		return axios.post('/api/voucher/book/sign-export', params, {
			responseType: 'blob',
			headers: {author: Utils.getAuthor() || 'gson', 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'multipart/form-data'}
		})
	},
	bookVerify(params) {
		return axios.post('/api/voucher/book/verify', params, {
			headers: {author: Utils.getAuthor() || 'gson', 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'multipart/form-data'}
		})
	},
	bookExportBegin(params = {}) {
		return Ajax.post(`/voucher/book/export-begin?` + Qs.stringify(params), {})
	},
	bookExportPage(exportId, index, params) {
		return axios.post(`/api/voucher/book/export-page?exportId=${exportId}&index=${index}`, params, {
			headers: {author: Utils.getAuthor() || 'gson', 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'multipart/form-data'}
		})
	},
	bookExportFinish(exportId) {
		return axios.post(`/api/voucher/book/export-finish?exportId=${exportId}`, {}, {
			responseType: 'blob',
			headers: {author: Utils.getAuthor() || 'gson', 'X-Requested-With': 'XMLHttpRequest'}
		})
	},
	bookExportCancel(exportId) {
		return Ajax.post(`/voucher/book/export-cancel?exportId=${exportId}`, {}).catch(() => {})
	},
	summaryTemplate: {
		list() {
			return Ajax.get(`/voucher/summary/template`)
		},
		save(params = {}) {
			return Ajax.post(`/voucher/summary/template`, params)
		},
		delete(id) {
			return Ajax.delete(`/voucher/summary/template/${id}`)
		}
	},
	sign(params = {}) {
		return Ajax.post(`/voucher/sign`, Qs.stringify(params))
	},
	uploadAttachment(voucherId, params) {
		return Ajax.post(`/voucher/attachment/${voucherId}`, params, {'Content-Type': 'multipart/form-data'})
	},
	deleteAttachment(voucherId, index) {
		return Ajax.delete(`/voucher/attachment/${voucherId}?index=${index}`)
	},
	attachmentUrl(voucherId, index) {
		return `/api/voucher/attachment/download?voucherId=${voucherId}&index=${index}`
	},
	log(params = {}) {
		return Ajax.get(`/voucher/log`, params)
	},
	cover(params = {}) {
		return Ajax.get(`/voucher/cover`, params)
	},
	summaryTable(params = {}) {
		return Ajax.get(`/voucher/summaryTable`, params)
	},
	nextUnauditedId(params = {}) {
		return Ajax.get(`/voucher/nextUnauditedId`, params)
	},
	split(params = {}) {
		return Ajax.post(`/voucher/split`, Qs.stringify(params, {indices: false}))
	},
	dustbin(params = {}) {
		return Ajax.get(`/voucher/dustbin`, params)
	},
	dustbinRestore(params = {}) {
		return Ajax.post(`/voucher/dustbin/restore`, Qs.stringify(params, {indices: false}))
	},
	dustbinDestroy(params = {}) {
		return Ajax.post(`/voucher/dustbin/destroy`, Qs.stringify(params, {indices: false}))
	},
	dustbinClear() {
		return Ajax.post(`/voucher/dustbin/clear`, {})
	},
	voidVoucher(params = {}) {
		return Ajax.post(`/voucher/void`, Qs.stringify(params, {indices: false}))
	},
	unvoidVoucher(params = {}) {
		return Ajax.post(`/voucher/unvoid`, Qs.stringify(params, {indices: false}))
	},
	reject(params = {}) {
		return Ajax.post(`/voucher/reject`, Qs.stringify(params, {indices: false}))
	},
	importTemplate() {
		return `/api/voucher/import/template`
	},
	batchSign(params = {}) {
		return Ajax.post(`/voucher/batchSign`, Qs.stringify(params, {indices: false}))
	},
	history: {
		list(voucherId) {
			return Ajax.get(`/voucher/history`, {voucherId})
		},
		detail(historyId) {
			return Ajax.get(`/voucher/history/${historyId}`)
		},
		rollback(historyId) {
			return Ajax.post(`/voucher/history/rollback`, Qs.stringify({historyId}))
		}
	},
	autoTransfer: {
		list() {
			return Ajax.get(`/voucher/auto-transfer`)
		},
		get(id) {
			return Ajax.get(`/voucher/auto-transfer/${id}`)
		},
		save(params = {}) {
			return Ajax.post(`/voucher/auto-transfer`, params)
		},
		delete(id) {
			return Ajax.delete(`/voucher/auto-transfer/${id}`)
		},
		execute(params = {}) {
			return Ajax.post(`/voucher/auto-transfer/execute`, Qs.stringify(params, {indices: false}))
		}
	}
}
